export const countries = [
    $localize`Abkhazia`,
    $localize`Afghanistan`,
    $localize`Åland Islands`,
    $localize`Albania`,
    $localize`Algeria`,
    $localize`American Samoa`,
    $localize`Andorra`,
    $localize`Angola`,
    $localize`Anguilla`,
    $localize`Antarctica`,
    $localize`Antigua & Barbuda`,
    $localize`Argentina`,
    $localize`Armenia`,
    $localize`Artsakh`,
    $localize`Aruba`,
    $localize`Australia`,
    $localize`Austria`,
    $localize`Azerbaijan`,
    $localize`Bahamas`,
    $localize`Bahrain`,
    $localize`Bangladesh`,
    $localize`Barbados`,
    $localize`Belarus`,
    $localize`Belgium`,
    $localize`Belize`,
    $localize`Benin`,
    $localize`Bermuda`,
    $localize`Bhutan`,
    $localize`Bolivia`,
    $localize`Bosnia & Herzegovina`,
    $localize`Botswana`,
    $localize`Bouvet Island`,
    $localize`Brazil`,
    $localize`British Indian Ocean Territory`,
    $localize`British Virgin Islands`,
    $localize`Brunei`,
    $localize`Bulgaria`,
    $localize`Burkina Faso`,
    $localize`Burundi`,
    $localize`Cambodia`,
    $localize`Cameroon`,
    $localize`Canada`,
    $localize`Cape Verde`,
    $localize`Caribbean Netherlands`,
    $localize`Cayman Islands`,
    $localize`Central African Republic`,
    $localize`Chad`,
    $localize`Chile`,
    $localize`China`,
    $localize`Christmas Island`,
    $localize`Cocos`,
    $localize`Colombia`,
    $localize`Comoros`,
    $localize`Congo`,
    $localize`Cook Islands`,
    $localize`Costa Rica`,
    $localize`Croatia`,
    $localize`Cuba`,
    $localize`Curaçao`,
    $localize`Cyprus`,
    $localize`Czechia`,
    $localize`Côte d’Ivoire`,
    $localize`Denmark`,
    $localize`Djibouti`,
    $localize`Dominica`,
    $localize`Dominican Republic`,
    $localize`Ecuador`,
    $localize`Egypt`,
    $localize`El Salvador`,
    $localize`Equatorial Guinea`,
    $localize`Eritrea`,
    $localize`Estonia`,
    $localize`Eswatini`,
    $localize`Ethiopia`,
    $localize`Falkland Islands`,
    $localize`Faroe Islands`,
    $localize`Fiji`,
    $localize`Finland`,
    $localize`France`,
    $localize`French Guiana`,
    $localize`French Polynesia`,
    $localize`French Southern Territories`,
    $localize`Gabon`,
    $localize`Gambia`,
    $localize`Georgia`,
    $localize`Germany`,
    $localize`Ghana`,
    $localize`Gibraltar`,
    $localize`Greece`,
    $localize`Greenland`,
    $localize`Grenada`,
    $localize`Guadeloupe`,
    $localize`Guam`,
    $localize`Guatemala`,
    $localize`Guernsey`,
    $localize`Guinea`,
    $localize`Guinea-Bissau`,
    $localize`Guyana`,
    $localize`Haiti`,
    $localize`Heard & McDonald Islands`,
    $localize`Honduras`,
    $localize`Hong Kong SAR China`,
    $localize`Hungary`,
    $localize`Iceland`,
    $localize`India`,
    $localize`Indonesia`,
    $localize`Iran`,
    $localize`Iraq`,
    $localize`Ireland`,
    $localize`Isle of Man`,
    $localize`Israel`,
    $localize`Italy`,
    $localize`Jamaica`,
    $localize`Japan`,
    $localize`Jersey`,
    $localize`Jordan`,
    $localize`Kazakhstan`,
    $localize`Kenya`,
    $localize`Kiribati`,
    $localize`Kosovo`,
    $localize`Kuwait`,
    $localize`Kyrgyzstan`,
    $localize`Laos`,
    $localize`Latvia`,
    $localize`Lebanon`,
    $localize`Lesotho`,
    $localize`Liberia`,
    $localize`Libya`,
    $localize`Liechtenstein`,
    $localize`Lithuania`,
    $localize`Luxembourg`,
    $localize`Macao SAR China`,
    $localize`Madagascar`,
    $localize`Malawi`,
    $localize`Malaysia`,
    $localize`Maldives`,
    $localize`Mali`,
    $localize`Malta`,
    $localize`Marshall Islands`,
    $localize`Martinique`,
    $localize`Mauritania`,
    $localize`Mauritius`,
    $localize`Mayotte`,
    $localize`Mexico`,
    $localize`Micronesia`,
    $localize`Moldova`,
    $localize`Monaco`,
    $localize`Mongolia`,
    $localize`Montenegro`,
    $localize`Montserrat`,
    $localize`Morocco`,
    $localize`Mozambique`,
    $localize`Myanmar`,
    $localize`Namibia`,
    $localize`Nauru`,
    $localize`Nepal`,
    $localize`Netherlands`,
    $localize`New Caledonia`,
    $localize`New Zealand`,
    $localize`Nicaragua`,
    $localize`Niger`,
    $localize`Nigeria`,
    $localize`Niue`,
    $localize`Norfolk Island`,
    $localize`North Korea`,
    $localize`North Macedonia`,
    $localize`Northern Cyprus`,
    $localize`Northern Mariana Islands`,
    $localize`Norway`,
    $localize`Oman`,
    $localize`Pakistan`,
    $localize`Palau`,
    $localize`Palestinian Territories`,
    $localize`Panama`,
    $localize`Papua New Guinea`,
    $localize`Paraguay`,
    $localize`Peru`,
    $localize`Philippines`,
    $localize`Pitcairn Islands`,
    $localize`Poland`,
    $localize`Portugal`,
    $localize`Puerto Rico`,
    $localize`Qatar`,
    $localize`Romania`,
    $localize`Russia`,
    $localize`Rwanda`,
    $localize`Réunion`,
    $localize`Sahrawi Arab Democratic Republic`,
    $localize`Samoa`,
    $localize`San Marino`,
    $localize`Saudi Arabia`,
    $localize`Senegal`,
    $localize`Serbia`,
    $localize`Seychelles`,
    $localize`Sierra Leone`,
    $localize`Singapore`,
    $localize`Sint Maarten`,
    $localize`Slovakia`,
    $localize`Slovenia`,
    $localize`Solomon Islands`,
    $localize`Somalia`,
    $localize`Somaliland`,
    $localize`South Africa`,
    $localize`South Georgia & South Sandwich Islands`,
    $localize`South Korea`,
    $localize`South Ossetia`,
    $localize`South Sudan`,
    $localize`Spain`,
    $localize`Sri Lanka`,
    $localize`St. Barthélemy`,
    $localize`St. Helena`,
    $localize`St. Kitts & Nevis`,
    $localize`St. Lucia`,
    $localize`St. Martin`,
    $localize`St. Pierre & Miquelon`,
    $localize`St. Vincent & Grenadines`,
    $localize`Sudan`,
    $localize`Suriname`,
    $localize`Svalbard & Jan Mayen`,
    $localize`Sweden`,
    $localize`Switzerland`,
    $localize`Syria`,
    $localize`São Tomé & Príncipe`,
    $localize`Taiwan`,
    $localize`Tajikistan`,
    $localize`Tanzania`,
    $localize`Thailand`,
    $localize`Timor-Leste`,
    $localize`Togo`,
    $localize`Tokelau`,
    $localize`Tonga`,
    $localize`Transnistria`,
    $localize`Trinidad & Tobago`,
    $localize`Tunisia`,
    $localize`Turkey`,
    $localize`Turkmenistan`,
    $localize`Turks & Caicos Islands`,
    $localize`Tuvalu`,
    $localize`U.S. Outlying Islands`,
    $localize`U.S. Virgin Islands`,
    $localize`Uganda`,
    $localize`Ukraine`,
    $localize`United Arab Emirates`,
    $localize`United Kingdom`,
    $localize`United States`,
    $localize`Uruguay`,
    $localize`Uzbekistan`,
    $localize`Vanuatu`,
    $localize`Vatican City`,
    $localize`Venezuela`,
    $localize`Vietnam`,
    $localize`Wallis & Futuna`,
    $localize`Western Sahara`,
    $localize`Yemen`,
    $localize`Zambia`,
    $localize`Zimbabwe`
];
